var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"py-5"},[_c('ul',{staticClass:"timeline"},_vm._l((_vm.items),function(item,i){return _c('li',{key:i,staticClass:"timeline-item mb-5"},[_vm._t("default",null,{"data":{item: item, index: i}})],2)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }